export const accessDevicesTabs = [
  {
    value: "basicInfo",
    label: "기본정보",
  },
];
